import { Component, ElementRef, Output, EventEmitter, ViewChild } from '@angular/core';
import * as $ from 'jquery'

@Component({
  selector: 'xe-visibility',
  templateUrl: 'xe-visibility.html'
})
export class XeVisibilityComponent {
  @ViewChild('element', { read: ElementRef }) element;
  @Output() didEnter = new EventEmitter<boolean>();
  @Output() didLeave = new EventEmitter<any>();
  visible: boolean = false;
  init: boolean = false;
  timeout = null;

  constructor() {        
  }

  ngAfterViewChecked() {
    if (this.timeout) {
      window.clearTimeout(this.timeout);
      this.timeout = null;
    }

    if (!this.check()) {
      this.timeout = window.setTimeout(() => {
        this.timeout = null;
        this.check();
      }, 100);
    }
  }

  check() {
    let change = false;
    if (this.element && this.element.nativeElement) {
      const offset = $(this.element.nativeElement).offset();
      let visible = false;
      this.element.nativeElement.style.pointerEvents = 'initial';
      let element: any = document.elementFromPoint(offset.left + 5, offset.top + 5);
      this.element.nativeElement.style.pointerEvents = 'none';
      while (element) {
        if (element === this.element.nativeElement) {
          visible = true;
          break;
        }
        element = element.parentNode;
      }

      if (this.visible !== visible) {
        change = true;
        if (visible)
          this.didEnter.emit(this.init);
        else
          this.didLeave.emit();
      }
      this.visible = visible;
      this.init = true;      
    }
    return change;
  }
}



// WEBPACK FOOTER //
// ./src/components/xe-visibility/xe-visibility.ts